import { Dispatch, FC, SetStateAction } from "react";
import styles from "./Checkbox.module.css";

interface CheckboxProps {
  text?: string;
  checked: boolean;
  indeterminate?: boolean;
  setChecked?: Dispatch<SetStateAction<boolean>>;
  toggleChecked?: () => void;
  disabled?: boolean;
}

const Checkbox: FC<CheckboxProps> = ({
  text,
  checked,
  indeterminate = false,
  setChecked,
  toggleChecked,
  disabled = false,
}) => {
  const handleChange = () => {
    if (disabled) return;
    if (setChecked) {
      setChecked((c) => !c);
    } else if (toggleChecked) {
      toggleChecked();
    }
  };

  return (
    <label className={styles.container}>
      <div className={styles.checkbox}>
        <input
          type="checkbox"
          checked={checked}
          ref={(el) => {
            if (el) {
              el.indeterminate = indeterminate;
            }
          }}
          onChange={handleChange}
          disabled={disabled}
        />
        <span className={styles.checkmark}></span>
      </div>
      <p>{text}</p>
    </label>
  );
};

export default Checkbox;
